module.exports = __webpack_public_path__ + "static/media/ideal-Logo@2x.2d0545b3.png";